import ClassList from "./ClassList.js"

export default class Component extends React.Component {

  constructor (props, context) {
    super(props, context)

    this.state = {
      l10n: this.player.l10n
    }
    this.classList = new ClassList(this, this.props.classList)
  }

  static get contextTypes() {
    return {
      player: PropTypes.object,
      config: PropTypes.object,
      plugin: PropTypes.object
    }
  }

  get player() {
    return this.props.player || this.context.player
  }

  get config() {
    return this.props.config || this.context.config
  }

  get l10n() {
    return this.state.l10n
  }

  get plugin() {
    return this.context.plugin
  }

  get className() {
    let className = this.props.className || ""
    className += ` ${this.classList}`

    return className.trim()
  }

  get textContent() {
    return this.props.textContent || this.state.textContent
  }

  get children() {
    return this.props.children || []
  }

  get element() {
    return this.refs.element
  }

  get dom() {
    return this.element || ReactDOM.findNode(this)
  }

  get data() {
    return this.props.data || {}
  }

  get playerEventMap() {
    const events = []

    if (this.player == null)
      return events

    Object.values(akamai.amp.Events).forEach((type) => {
      let key = `on${type}`
      if (typeof this[key] != "function")
        return
      events.push({key: key, type: type})
    })

    return events
  }

  get propsList() {
    const { className, classList, data, textContent, ...props } = this.props
    return props
  }

  getLocalizedString(key) {
    return this.player.getLocalizedString(key)
  }

  onlanguagechange() {
    this.setState({l10n: this.player.l10n})
  }

  bindHandlers(handlers) {
    if (handlers == null || handlers.length <= 0)
      return

    handlers.forEach((handler) => {
      if (typeof this[handler] != "function")
        return
      this[handler] = this[handler].bind(this)
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    let state = this.state
    let props = this.props

    if (nextState != null) {
      for (let key in nextState) {
        if (nextState[key] != state[key]) {
          return true
        }
      }
    }

    // TODO: Is this needed?
    if (nextProps != null) {
      for (let key in nextProps) {
        if (nextProps[key] != props[key]) {
          return true
        }
      }
    }

    return false
  }

  componentWillMount() {
    this.playerEventMap.forEach((event) => {
      this[event.key] = this[event.key].bind(this)
      this.player.addEventListener(event.type, this[event.key])
    })
  }

  componentWillUnmount() {
    this.playerEventMap.forEach((event) => {
      this.player.removeEventListener(event.type, this[event.key])
    })
  }

  render() {
    return (
      <div ref="element" {...this.propsList} className={this.className}>
        {this.textContent}
        {this.children}
      </div>
    )
  }
}
